<template>
  <section class="referral-card top-round d-flex flex-row justify-content-between align-items-center col-xs-12 py-4">
    <a class="text-decoration-none payment-history lead py-3 d-inline cursor-pointer" @click="ShowPaymentHistory()">
      {{ $t('UserProfile.Wallet.SubscribedUser.PaymentHistory') }}
    </a>
    <img height="48" src="@/assets/icons/dollar.svg" class="rounded-circle bg-success-light px-0 py-2">
  </section>
</template>

<script>
export default {
  name: 'UserProfilePaymentHistoryCard',
  methods: {
    ShowPaymentHistory () {
      this.$emit('ShowPaymentHistory')
    }
  }
}
</script>
